import * as e from "react";
const a = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 18.558V5.442l-5-1.667v16.45l5-1.667zM13 19h-3v-.5a1 1 0 10-2 0v.5a2 2 0 002 2h3v.613a1 1 0 001.316.948l7-2.333a1 1 0 00.684-.949V4.721a1 1 0 00-.684-.949l-7-2.333A1 1 0 0013 2.387V3h-3a2 2 0 00-2 2v1a1 1 0 102 0V5h3v14zM7.71 8.3l3 3a1 1 0 010 1.4l-3 3c-.95.95-2.36-.46-1.42-1.4l1.3-1.3H3a1 1 0 110-2h4.59l-1.3-1.3c-.94-.94.47-2.35 1.42-1.4z",
      fill: "#2d6ded"
    }
  )
);
export {
  a as default
};
